import React, { useContext } from "react";
import { AiIcon } from "../../../VectorIcons/AiIcon";
import { Box, Typography } from "@mui/material";
import { RecommendationsAPIContext } from "../../../../context/RecommendationsAPI/recommendationsAPIContext";
import SimpleScriptBox from "../../../../views/ProjectSheet/SimpleScriptBox/SimpleScriptBox";

export function NoAttachmentsToProcessModalOpen({ open, title }) {
  const { setCloseModal } = useContext(RecommendationsAPIContext);

  return (
    <SimpleScriptBox
      open={open}
      title={title}
      icon={<AiIcon color="#FFF" />}
      size="large"
      removePadding={true}
      allowOverflow={true}
      toggleScriptBox={() => setCloseModal()}
    >
      <Box sx={{ backgroundColor: "#FFF" }}>
        <Typography
          sx={{
            textAlign: "center",
            fontFamily: "inherit",
            fontSize: "16px",
            padding: "64px 32px",
          }}
        >
          Não há arquivos disponiveis para fazer a leitura
        </Typography>
      </Box>
    </SimpleScriptBox>
  );
}
